import * as Y from 'yjs';

import { getContentObjectsMap, useObservedProperty, validateYMap } from './yjs';

export function useWidgetStyle<T = string>(document: Y.Doc, widgetId: string, property: string) {
  const contentObjectMap = getContentObjectsMap(document);
  const widgetStyleMap = validateYMap(validateYMap(contentObjectMap.get(widgetId)).get('style'));
  return useObservedProperty<T | undefined>(widgetStyleMap, property);
}
